import React, { useEffect, useState } from "react";
import { X, Zap, ArrowRight, Sparkles } from "lucide-react";

// Launch window is server-driven: /api/public/delta-launch -> { active, ends_at } (24h from first production boot).
const LS_BASE = "ws_delta_launch_popup_dismissed";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function useCountdown(end) {
  const [left, setLeft] = useState(end - Date.now());
  useEffect(() => { const t = setInterval(() => setLeft(end - Date.now()), 1000); return () => clearInterval(t); }, [end]);
  if (left <= 0) return "00:00:00";
  const h = Math.floor(left / 36e5), m = Math.floor((left % 36e5) / 6e4), s = Math.floor((left % 6e4) / 1e3);
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}

export const DeltaLaunchPopup = ({ onConnect, ctaLabel = "Connect your Delta account" }) => {
  const [open, setOpen] = useState(false);
  const [lsKey, setLsKey] = useState(LS_BASE);
  const [endsAt, setEndsAt] = useState(0);
  const left = useCountdown(endsAt);
  useEffect(() => {
    let t;
    fetch(`${API}/public/delta-launch`).then((r) => r.json()).then((d) => {
      if (!d.active) return;
      const k = `${LS_BASE}_${d.started_at || ""}`;  // dismissal is per window — Restart re-shows to everyone
      setLsKey(k);
      if (localStorage.getItem(k)) return;
      setEndsAt(new Date(d.ends_at).getTime());
      t = setTimeout(() => setOpen(true), 900);
    }).catch(() => {});
    return () => clearTimeout(t);
  }, []);
  const close = () => { localStorage.setItem(lsKey, "1"); setOpen(false); };
  if (!open) return null;
  return (
    <div className="ws-launch-overlay" onClick={close} data-testid="delta-launch-popup">
      <div className="ws-launch-card" onClick={(e) => e.stopPropagation()}>
        <div className="ws-launch-aurora" aria-hidden />
        <div className="ws-launch-rays" aria-hidden />
        <button className="ws-launch-close" onClick={close} aria-label="Close" data-testid="delta-launch-close"><X className="w-4 h-4" /></button>
        <div className="ws-launch-eyebrow"><Zap className="w-3.5 h-3.5" /> Now live · {left} left</div>
        <div className="ws-launch-logos">
          <span className="ws-launch-logo"><img src="/landing/delta.png" alt="Delta Exchange" /></span>
          <span className="ws-launch-x">×</span>
          <span className="ws-launch-logo ws"><img src="/wsj-logo.webp" alt="Wealth Secret" /></span>
        </div>
        <h3 className="ws-launch-title">
          <span className="ws-launch-delta">Delta Exchange</span> × <span className="ws-brand-name">Wealth Secret</span><br />Data Terminal is <span className="ws-launch-live">LIVE</span>
        </h3>
        <p className="ws-launch-sub">Connect your Delta account and check your edge — crypto futures & options now sync into your journal, analytics and WS Coach.</p>
        <button onClick={() => { close(); onConnect?.(); }} className="ws-btn-3d ws-launch-cta" data-testid="delta-launch-cta">
          <Sparkles className="w-4 h-4" /> {ctaLabel} <ArrowRight className="w-4 h-4" />
        </button>
        <button onClick={close} className="ws-launch-later" data-testid="delta-launch-later">Maybe later</button>
      </div>
    </div>
  );
};

export default DeltaLaunchPopup;
